module.exports = __webpack_public_path__ + "img/Nextpay-logo-white.970e9f68.svg";